import React from 'react';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useRole, ROLE_TYPES } from "hooks/useRole";

const ExistingLeadCard = ({ leadData, clientName, clientPhone, clientCountryCode }) => {
  const history = useHistory();
  const { isAnyRole } = useRole();
  // Destructuring for clarity
  const { _id, status, assignee, vehicle } = leadData;

  const name = clientName;
  const phone = clientCountryCode ? `${clientCountryCode} ${clientPhone}` : clientPhone;

  return (
    <div
      style={{
        height: "fit-content",
        width: '100%',
        maxWidth: '384px',
        borderLeft: '4px solid #3b82f6',
        backgroundColor: '#ffffff',
        padding: '1rem',
        boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
        borderTopRightRadius: '0.5rem',
        borderBottomRightRadius: '0.5rem',
        borderTop: '1px solid #f3f4f6',
        borderRight: '1px solid #f3f4f6',
        borderBottom: '1px solid #f3f4f6',
      }}
    >
      {/* Header */}
      <div className="d-flex align-items-center mb-3" style={{ gap: '0.5rem' }}>
        <i className="bx bx-error-circle" style={{ color: '#3b82f6', fontSize: '1rem' }} />
        <h3 className="mb-0" style={{ fontSize: '0.875rem', fontWeight: 600, color: '#111827' }}>Lead Already Exists</h3>
      </div>

      {/* Grid Content */}
      <div style={{ display: 'grid', gridTemplateColumns: '1fr', rowGap: '0.5rem', marginBottom: '1rem', fontSize: '0.75rem' }}>
        <div className="d-flex align-items-center" style={{ gap: '0.75rem', color: '#4b5563' }}>
          <i className="bx bx-user" style={{ color: '#9ca3af', fontSize: '0.875rem', minWidth: '14px' }} />
          <span style={{ fontWeight: 500, color: '#111827', textTransform: 'uppercase', letterSpacing: '-0.025em' }}>{name || 'Unknown Name'}</span>
        </div>

        <div className="d-flex align-items-center" style={{ gap: '0.75rem', color: '#4b5563' }}>
          <i className="bx bx-phone" style={{ color: '#9ca3af', fontSize: '0.875rem', minWidth: '14px' }} />
          <span>{phone}</span>
        </div>

        {vehicle?.name && (
          <div className="d-flex align-items-center" style={{ gap: '0.75rem', color: '#4b5563' }}>
            <i className="bx bx-car" style={{ color: '#9ca3af', fontSize: '0.875rem', minWidth: '14px' }} />
            <span>{vehicle.name}</span>
          </div>
        )}

        <div className="d-flex align-items-center" style={{ gap: '0.75rem' }}>
          <div className="d-flex align-items-center flex-grow-1" style={{ gap: '0.75rem', color: '#4b5563' }}>
            <i className="bx bx-user-check" style={{ color: '#9ca3af', fontSize: '0.875rem', minWidth: '14px' }} />
            <span>Assigned to <span style={{ color: '#111827', fontWeight: 500 }}>{assignee?.name || 'Unassigned'}</span></span>
          </div>
          <span
            style={{
              backgroundColor: '#eff6ff',
              color: '#1d4ed8',
              padding: '0.125rem 0.5rem',
              borderRadius: '9999px',
              fontWeight: 700,
              fontSize: '10px',
              textTransform: 'uppercase'
            }}
          >
            {status || 'N/A'}
          </span>
        </div>
      </div>

      {/* Action */}
      {isAnyRole([ROLE_TYPES.SUPER_ADMIN, ROLE_TYPES.ADMIN]) ? (
        <button
          type="button"
          onClick={() => history.push(`/lead-details/${_id}`)}
          style={{
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '0.5rem',
            padding: '0.5rem 0',
            fontSize: '0.75rem',
            fontWeight: 500,
            color: '#2563eb',
            backgroundColor: '#eff6ff',
            border: 'none',
            borderRadius: '0.375rem',
            transition: 'background-color 0.2s',
            cursor: 'pointer'
          }}
          onMouseEnter={(e) => e.target.style.backgroundColor = '#dbeafe'}
          onMouseLeave={(e) => e.target.style.backgroundColor = '#eff6ff'}
        >
          View Full Profile
          <i className="bx bx-link-external" style={{ fontSize: '0.875rem' }} />
        </button>
      ) : (
        <div style={{ textAlign: 'center', fontSize: '0.75rem', color: '#dc2626', fontWeight: 500, padding: '0.5rem 0' }}>
          Please contact higher authority to view details.
        </div>
      )}
    </div>
  );
};

ExistingLeadCard.propTypes = {
  leadData: PropTypes.shape({
    _id: PropTypes.string,
    status: PropTypes.string,
    assignee: PropTypes.shape({
      name: PropTypes.string,
    }),
    vehicle: PropTypes.shape({
      name: PropTypes.string,
    }),
  }),
  clientName: PropTypes.string,
  clientPhone: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  clientCountryCode: PropTypes.string,
};

export default ExistingLeadCard;
